// react imports
import React, {useEffect} from "react";
import ProfileForm from "../components/form-components/ProfileForm"
import {MDBContainer} from 'mdb-react-ui-kit';
import { Helmet } from "react-helmet-async";


const Irjonnekunkpage = () => {

    useEffect(() => {
        setTimeout(() => window.scrollTo({
            top: 0,
            behavior: "smooth"
        }), 100);
    }, []);


    return (
        <>
            <Helmet>
                <title>Írjon nekünk - A Vértes Agorája</title>
            </Helmet>
            <section className="urlap-section" id="urlap-section">
                <MDBContainer style={{maxWidth: "1008px"}} className='p-0'>
                    <div className="kapcsolat-title">
                        <h1>Kérdése van? Miben segíthetünk?</h1>
                    </div>
                    <ProfileForm />
                </MDBContainer>
            </section>
        </>
    );
};

export default Irjonnekunkpage;
